export const TradingLeaderboardEvent = {
  RankingPageView: 'ranking_page_view',
  RankingPageMyRankClick: 'ranking_page_my_rank_click',
  LeaderboardInfoClick: 'leaderboard_info_click',
  LeaderboardTypeClick: 'leaderboard_type_click',
  LeaderboardTierClick: 'leaderboard_tier_click',
  LeaderboardRewardsDetailClick: 'leaderboard_rewards_detail_click',
  LeaderboardVipBenefitsClick: 'leaderboard_vip_benefits_click',
  LeaderboardSettingConfirmClick: 'leaderboard_setting_confirm_click',
  LeaderboardSettingClick: 'leaderboard_setting_click',
  LeaderboardTradeNowClick: 'leaderboard_trade_now_click',
  LeaderboardGotoLeagueClick: 'leaderboard_goto_league_click',
  LeaderboardShareRankClick: 'leaderboard_share_rank_click',
  LeaderboardPerformanceShareClick: 'leaderboard_performance_share_click',
  LeaderboardPerformanceDownloadClick: 'leaderboard_performance_download_click',
  RankingPageRankerClick: 'ranking_page_ranker_click',
  RankingPageRankerTooltipClick: 'ranking_page_ranker_tooltip_click',
  TopTraderStrategyModalView: 'top_trader_strategy_modal_view',
  TopTraderStrategyExploreNowClick: 'top_trader_strategy_explore_now_click',

  // onboardings
  LeagueOnboardingView: 'league_onboarding_view',
  LeagueOnboardingClick: 'league_onboarding_click',

  // recurring tc banner
  TieredTcGuideBottomSheetView: 'tiered_tc_guide_bottom_sheet_view',
  TieredTcGuideBottomSheetTcClick: 'tiered_tc_guide_bottom_sheet_tc_click',
  TieredTcGuideBottomSheetGotitClick: 'tiered_tc_guide_bottom_sheet_gotit_click',
} as const;

type TradingLeaderboardInterval = 'WEEKLY' | 'MONTHLY';
type TradingLeaderboardTier = 'WHALE' | 'SHARK' | 'STARTER' | 'ALL';

export interface TradingLeaderboardEventDataType {
  [TradingLeaderboardEvent.RankingPageView]: {
    interval: TradingLeaderboardInterval;
    tier: TradingLeaderboardTier;
    redirect_page?: string;
  };
  [TradingLeaderboardEvent.RankingPageMyRankClick]: {
    realized_pnl: number | null;
    challenge_rank: string;
  };
  [TradingLeaderboardEvent.LeaderboardTypeClick]: {
    interval: TradingLeaderboardInterval;
  };
  [TradingLeaderboardEvent.LeaderboardTierClick]: {
    interval: TradingLeaderboardInterval;
    tier: TradingLeaderboardTier;
  };
  [TradingLeaderboardEvent.LeaderboardRewardsDetailClick]: {
    vip_status: boolean;
  };
  [TradingLeaderboardEvent.LeaderboardSettingConfirmClick]: {
    view_my_rank: boolean;
  };
  [TradingLeaderboardEvent.LeaderboardSettingClick]: {
    from_route: 'setting_button' | 'profile_section';
  };
  [TradingLeaderboardEvent.LeaderboardTradeNowClick]: {
    interval: TradingLeaderboardInterval;
    ranking?: number;
    tier: TradingLeaderboardTier;
  };
  [TradingLeaderboardEvent.LeaderboardGotoLeagueClick]: {
    from_league: TradingLeaderboardTier;
    to_league: TradingLeaderboardTier;
  };
  [TradingLeaderboardEvent.LeaderboardShareRankClick]: {
    interval: TradingLeaderboardInterval;
    tier: TradingLeaderboardTier;
    ranking?: number;
  };
  [TradingLeaderboardEvent.LeaderboardPerformanceShareClick]: {
    interval: TradingLeaderboardInterval;
    tier: TradingLeaderboardTier;
    league_type: 'all' | 'myleague';
    ranking?: number;
  };
  [TradingLeaderboardEvent.LeaderboardPerformanceDownloadClick]: {
    interval: TradingLeaderboardInterval;
    tier: TradingLeaderboardTier;
    league_type: 'all' | 'myleague';
    ranking?: number;
  };
  [TradingLeaderboardEvent.RankingPageRankerClick]: {
    profile_id: string;
    clicked_user_name: string;
    clicked_ranking: number;
    is_influencer: boolean;
  };
  [TradingLeaderboardEvent.RankingPageRankerTooltipClick]: {};
  [TradingLeaderboardEvent.TopTraderStrategyExploreNowClick]: {};

  // onboardings
  [TradingLeaderboardEvent.LeagueOnboardingView]: {
    tier?: TradingLeaderboardTier;
    event_location: 'main_page' | 'leaderboard';
  };
  [TradingLeaderboardEvent.LeagueOnboardingClick]: {
    tier?: TradingLeaderboardTier;
    event_location: 'main_page' | 'leaderboard';
  };
}
